export default __webpack_public_path__ + "static/media/raiffeisen_s2.a636b2f4.png";